<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="stockTakings.data"
      style="width: 100%"
      row-key="id"
      highlight-current-row
      :row-class-name="'pointer-row'"
      @sort-change="handleSortChange"
      @row-click="(row) => $router.replace('/processes/stock-takings/stock-takings/view/' + row.id)"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="70"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="stockTaking"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :stockTaking="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="stockTakings.per_page"
        layout="total, prev, pager, next"
        :total="stockTakings.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'asc',
        },
      };
    },
    computed: {
      stockTakings() {
        return this.$store.getters['stockTaking/stockTakings'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['stockTaking/tableConfig']));
      },
      loading() {
        return this.$store.getters['stockTaking/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('stockTaking/setFilterString', '');
      this.$store.commit('stockTaking/setCurrentPage', this.currentPage);
      this.$store.commit('stockTaking/setSorting', this.currentSort);
      await this.$store.dispatch('stockTaking/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('stockTaking/setCurrentPage', val);
        this.$store.dispatch('stockTaking/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('stockTaking/setSorting', { prop, order });
          this.$store.dispatch('stockTaking/fetchAll');
        }
      },
    },
  };
</script>

